// Added by Sendistovan
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header__inline-menu').forEach(function (menu) {
    menu.querySelectorAll('.header__active-menu-item').forEach(function (activeItem) {
      const menuItem = activeItem.closest('.header__menu-item');
      if (menuItem) {
        menuItem.style.borderBottom = '1px solid #383F51';
      }
    });
  });
});